export const PartyTypeConstant = [
    {
        id: 1,
        name: 'Consignee',
        nameKey: 'Consignee'
    },
    {
        id: 2,
        name: 'Transporter',
        nameKey: 'Transporter'
    },
    {
        id: 3,
        name: 'Both',
        nameKey: 'Both'
    },
];
